const validate = values => {
  const errors = {};
  if (!values.cad_questao_duelo) {
    errors.cad_questao_duelo = 'Campo Obrigatório';
  }
  if (!values.cad_questao_a) {
    errors.cad_questao_a = 'Campo Obrigatório';
  }
  if (!values.cad_questao_b) {
    errors.cad_questao_b = 'Campo Obrigatório';
  }
  // if (!values.cad_questao_c) {
  //   errors.cad_questao_c = 'Campo Obrigatório';
  // }
  // if (!values.cad_questao_d) {
  //   errors.cad_questao_d = 'Campo Obrigatório';
  // }
  if (!values.cad_questao_dis) {
    errors.cad_questao_dis = 'Campo Obrigatório';
  }
  if (!values.optionQuestao) {
    errors.optionQuestao = 'Campo Obrigatório';
  }

  return errors;
};

export default validate;




// WEBPACK FOOTER //
// ./src/service/validate_questao.js